import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";

export const TimelineViewEventPositionRecord = Record({
  markerRelativeRect: FlatRectRecord(),
  eventCardRelativeRect: FlatRectRecord(),
  totalRect: FlatRectRecord(),
  childrenArrowRect: FlatRectRecord(),
  childrenBorderRect: FlatRectRecord(),
  parentShadowMarkerRect: FlatRectRecord(),
  uncertainStartRect: FlatRectRecord(),
  uncertainEndRect: FlatRectRecord(),
  startRectWithChildren: FlatRectRecord(),
  endRectWithChildren: FlatRectRecord(),
  cardIsOnNewLine: Boolean
});

const data = {
  objects: {
    markerRelativeRect: "FlatRectRecord",
    eventCardRelativeRect: "FlatRectRecord",
    totalRect: "FlatRectRecord",
    childrenArrowRect: "FlatRectRecord",
    childrenBorderRect: "FlatRectRecord",
    parentShadowMarkerRect: "FlatRectRecord",
    uncertainStartRect: "FlatRectRecord",
    uncertainEndRect: "FlatRectRecord",
    startRectWithChildren: "FlatRectRecord",
    endRectWithChildren: "FlatRectRecord"
  }
};
createFromJS.registerCallback(
  "TimelineViewEventPositionRecord",
  createFromJS.createNestedCallback(TimelineViewEventPositionRecord, data)
);
